import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Save, CheckCircle } from 'lucide-react';
import { API_URL } from '../utils/cartApi';

const AdminSettings = () => {
  const [settings, setSettings] = useState({ adminName: '', phone: '', gstNo: '' });
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/api/settings`).then(res => setSettings(res.data));
  }, []);

  const handleSave = (e) => {
    e.preventDefault();
    axios.post(`${API_URL}/api/settings/update`, settings).then(() => {
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    });
  };

  return (
    <div className="p-8 bg-[#f5f2e8] min-h-screen">
      <div className="max-w-2xl">
        <h2 className="text-2xl font-bold text-maroon mb-6 uppercase border-b-2 border-maroon pb-2">Business Profile</h2>
        <form onSubmit={handleSave} className="bg-white p-8 border shadow-sm space-y-6">
          <div>
            <label className="text-xs font-bold text-gray-500 uppercase block mb-1">Admin Name</label>
            <input className="w-full border p-3 outline-none focus:border-maroon" value={settings.adminName} onChange={e => setSettings({...settings, adminName: e.target.value})} />
          </div>
          <div>
            <label className="text-xs font-bold text-gray-500 uppercase block mb-1">Business Phone</label>
            <input className="w-full border p-3 outline-none focus:border-maroon" value={settings.phone} onChange={e => setSettings({...settings, phone: e.target.value})} />
          </div>
          <div>
            <label className="text-xs font-bold text-gray-500 uppercase block mb-1">GST Number</label>
            <input className="w-full border p-3 outline-none focus:border-maroon font-mono" value={settings.gstNo} onChange={e => setSettings({...settings, gstNo: e.target.value})} />
          </div>
          <button type="submit" className="w-full bg-maroon text-white py-4 font-bold uppercase tracking-widest flex justify-center items-center">
            {saved ? <><CheckCircle size={18} className="mr-2"/> Saved Successfully</> : <><Save size={18} className="mr-2"/> Update Settings</>}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminSettings;